"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWithFilesSchema = exports.buildFileSchema = exports.buildSchema = void 0;
const z = require("zod");
const build_status_1 = require("./build-status");
const build_automation_1 = require("./build-automation");
exports.buildSchema = z.object({
    id: z.string(),
    projectId: z.string(),
    buildNumber: z.number().int().min(0),
    buildCompleted: z.date().optional(),
    status: build_status_1.buildStatusSchema,
    statusMessage: z.string().optional(),
    erroredFromStatus: build_status_1.buildStatusSchema.optional(),
    automationMode: build_automation_1.buildAutomationModeSchema.optional(),
    result: z.string().optional(),
    type: z.string(),
    typeRef: z.string().optional(),
    triggerEvent: z.string().optional(),
    triggerUrl: z.string().optional(),
    operationId: z.string().optional(),
    triggeredByUser: z.string().optional(),
    data: z.object({}).passthrough().optional(),
    displayName: z.string().optional(),
    hasUploadedFiles: z.boolean(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});
exports.buildFileSchema = z.object({
    id: z.string(),
    name: z.string(),
    uploadedAt: z.date(),
    sizeBytes: z.number().int().min(0),
    relativePath: z.string().optional(),
    uploadId: z.string().optional(),
});
exports.buildWithFilesSchema = exports.buildSchema.extend({
    files: z.array(exports.buildFileSchema),
});
//# sourceMappingURL=build.js.map